export default __webpack_public_path__ + "25d0b434cc2c35609cdf86f5d72d7a1a.png";